import { css, CSSResult } from 'lit'
import { csFormControl } from 'elements/_shared/form.style.js'
import { csColorAction } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const cseTextInput = {
  backgroundColor: css`var(--cse-text-input-background-color, ${csFormControl.backgroundColor})`,
  backgroundColorDisabled: css`var(--cse-text-input-background-color-disabled, ${csFormControl.backgroundColorDisabled})`,
  borderWidth: css`var(--cse-text-input-border-width, ${csFormControl.borderWidth})`,
  borderColor: css`var(--cse-text-input-border-color, ${csFormControl.borderColor})`,
  borderColorError: css`var(--cse-text-input-border-color-error, ${csFormControl.borderColorError})`,
  borderColorSuccess: css`var(--cse-text-input-border-color-success, ${csFormControl.borderColorSuccess})`,
  borderRadius: css`var(--cse-text-input-border-radius, ${csFormControl.borderRadius})`,
  color: css`var(--cse-text-input-color, ${csFormControl.color})`,
  colorDisabled: css`var(--cse-text-input-color-disabled, ${csFormControl.colorDisabled})`,
  fontSize: css`var(--cse-text-input-font-size, ${csFormControl.fontSize})`,
  fontFamily: css`var(--cse-text-input-font-family, ${csFormControl.fontFamily})`,
  width: css`var(--cse-text-input-width, 100%)`,
  gap: css`var(--cse-text-input-gap, ${csSpacing.spacing05})`,
  height: css`var(--cse-text-input-height, ${csFormControl.height})`,
  paddingInline: css`var(--cse-text-input-padding-x, ${csFormControl.paddingInline})`,
  paddingBlock: css`var(--cse-text-input-padding-y, ${csFormControl.paddingBlock})`,
  outlineFocus: css`var(--cse-text-input-outline-focus, ${csFormControl.outlineFocus})`,
  placeholderColor: css`var(--cse-text-input-placeholder-color, ${csFormControl.placeholderColor})`,
  prefixColor: css`var(--cse-text-input-prefix-color, ${csColorAction.primary})`,
  suffixColor: css`var(--cse-text-input-suffix-color, ${csFormControl.colorDisabled})`,
}

export const style: CSSResult = css`
  .cse-text-input {
    position: relative;
    background: ${cseTextInput.backgroundColor};
    border-width: ${cseTextInput.borderWidth};
    border-style: solid;
    border-color: ${cseTextInput.borderColor};
    border-radius: ${cseTextInput.borderRadius};
    color: ${cseTextInput.color};
    font-size: ${cseTextInput.fontSize};
    font-family: ${cseTextInput.fontFamily};
    width: ${cseTextInput.width};
    height: ${cseTextInput.height};
    padding-block: ${cseTextInput.paddingBlock};
    padding-inline: ${cseTextInput.paddingInline};
    display: flex;
    gap: ${cseTextInput.gap};
    justify-content: space-between;
    align-items: center;
    transition-duration: ${csTransition.duration};
    transition-timing-function: ${csTransition.timingFunction};
    transition-property: color, background-color, border-color;
  }

  input {
    all: unset;
    width: inherit;
    height: ${cseTextInput.height};
    font-size: ${cseTextInput.fontSize};
    font-family: ${cseTextInput.fontFamily};
    flex: 1;
  }

  input[type=number]::-webkit-outer-spin-button,
  input[type=number]::-webkit-inner-spin-button {
    margin: 0;
    -webkit-appearance: none;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }

  .cse-text-input-prefix {
    color: ${cseTextInput.prefixColor};
    --cse-text-color: ${cseTextInput.prefixColor};
  }

  .cse-text-input-suffix {
    color: ${cseTextInput.suffixColor};
    --cse-text-color: ${cseTextInput.suffixColor};
  }

  .cse-text-input.disabled {
    background-color: ${cseTextInput.backgroundColorDisabled};
    color: ${cseTextInput.colorDisabled};
  }

  .cse-text-input input::placeholder {
    color: ${cseTextInput.placeholderColor};
    opacity: 1;
  }

  .cse-text-input:has(input:focus-visible) {
    outline: ${cseTextInput.outlineFocus};
  }

  .cse-text-input.valid-error {
    border-color: ${cseTextInput.borderColorError};
  }

  .cse-text-input.valid-success {
    border-color: ${cseTextInput.borderColorSuccess};
  }
`
